import React, { FC } from 'react';
import { Browser } from 'components/Browser/Browser';
import { useAppStore } from 'stores/appStore';
import styles from '../StoreReadyStep.scss';
import { SkeletonGroup, SkeletonRectangle } from '@wix/design-system';

export const StoreReadyStepPreview: FC = () => {
  const siteUrl = useAppStore((state) => state.siteUrl);

  return (
    <div className={styles.storeReadyStepPreview}>
      <div className={styles.storeReadyStepPreviewContent}>
        <Browser headerUrl={siteUrl}>
          <div className={styles.storeReadyStepPreviewIframe}>
            <div className={styles.storeReadyStepPreviewIframeSkeleton}>
              <SkeletonGroup>
                <SkeletonRectangle height="2000px" />
              </SkeletonGroup>
            </div>
            <iframe src={siteUrl} title={siteUrl} />
          </div>
        </Browser>
      </div>
    </div>
  );
};
